import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let activeOrgId = null;
export function setActiveOrgId(id) {
  activeOrgId = id;
  if (id) localStorage.setItem("tovra.org", id);
  else localStorage.removeItem("tovra.org");
}
export function getActiveOrgId() {
  if (!activeOrgId) activeOrgId = localStorage.getItem("tovra.org") || localStorage.getItem("flowhq.org");
  return activeOrgId;
}

api.interceptors.request.use((cfg) => {
  const oid = getActiveOrgId();
  if (oid) cfg.headers["X-Org-Id"] = oid;
  return cfg;
});

export function formatApiErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export const wsUrl = (token, orgId) => {
  const proto = BACKEND_URL.startsWith("https") ? "wss" : "ws";
  const host = BACKEND_URL.replace(/^https?:\/\//, "");
  return `${proto}://${host}/api/ws?token=${encodeURIComponent(token)}${orgId ? `&org_id=${orgId}` : ""}`;
};
